import axios from "axios";

const apiClientDef = axios.create({
  baseURL: process.env.REACT_APP_API_HOST + "/api",
  headers: {
    Token: process.env.REACT_APP_TOKEN,
  },
});

const apiClientDev = axios.create({
  baseURL: process.env.REACT_APP_API_HOST + "/api",
  headers: {
    Token: process.env.REACT_APP_DEVTOKEN,
  },
});

const backendClient = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_HOST + process.env.REACT_APP_PREFIX,
  headers: {
    "X-Requested-With": "XMLHttpRequest",
  },
});

const fakeApiClient = axios.create({
  baseURL: process.env.REACT_APP_FAKE_API_HOST + "/api",
  headers: {
    Token: process.env.REACT_APP_DEVTOKEN,
  },
});

const ApiClient = { apiClientDef, apiClientDev, fakeApiClient, backendClient };
export default ApiClient;
